import { makeStyles } from 'tss-react/mui';

// Constants
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../../constants/typography';
import { pickIf } from '../../../../utils/pickIf';

export const useStyles = makeStyles()(
  (theme, { withChildren, isKiteUser, isMobileMode } = {}) => ({
    reorderButton: {
      paddingInline: theme.spacing(4),
    },
    trackButton: { paddingBlock: 0, paddingInline: '10px' },
    orderTime: { display: pickIf(isMobileMode, 'flex', 'initial') },
    caption: { color: '#929A92', fontSize: 12, marginRight: 10, marginTop: 5 },
    captionSmall: { color: '#929A92', fontSize: 12 },
    card: {
      backgroundColor: pickIf(withChildren, '#F4F4F4', 'white'),
      boxShadow: '0px 5px 15px rgba(44, 112, 172, 0.2)',
      borderRadius: pickIf(withChildren, '20px 20px 0px 0px', '20px'),
      paddingBottom: theme.spacing(2.75),
      height: 168,
      marginBottom: pickIf(withChildren, 0, theme.spacing(2.5)),
      '&:first-child': {
        marginTop: theme.spacing(2),
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.down('md')]: {
        height: 180,
        borderRadius: pickIf(withChildren, '10px 10px 0px 0px', 10),
        marginBottom: pickIf(withChildren, 0, theme.spacing(1.5)),
        paddingBottom: theme.spacing(1.25),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          height: 180,
          borderRadius: pickIf(withChildren, '10px 10px 0px 0px', 10),
          marginBottom: pickIf(withChildren, 0, theme.spacing(1.5)),
          paddingBottom: theme.spacing(1.25),
        }),
      },
    },
    headerText: {
      color: pickIf(isKiteUser, theme.palette.darkGrey, theme.palette.black),
      fontWeight: pickIf(isKiteUser, FONT_WEIGHT_BOLD, FONT_WEIGHT_SEMIBOLD),
      fontSize: '14px',
      [theme.breakpoints.down('md')]: {
        fontSize: '12px',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: '12px',
        }),
      },
    },
    text: {
      color: theme.palette.darkGrey,
      fontWeight: pickIf(isKiteUser, FONT_WEIGHT_REGULAR, FONT_WEIGHT_SEMIBOLD),
      fontSize: '14px',
      [theme.breakpoints.down('md')]: {
        fontSize: '12px',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: '12px',
        }),
      },
    },
    reorderContainer: {
      [theme.breakpoints.down('md')]: {
        paddingLeft: '5px !important',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          paddingLeft: '5px !important',
        }),
      },
      '& #reorder': {
        [theme.breakpoints.down('lg')]: {
          height: 36,
          width: 119,
        },
        [theme.breakpoints.down('md')]: {
          width: 130,
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            height: 36,
            width: 119,
          }),
        },
        [theme.breakpoints.downLandscape('md')]: {
          ...(theme.isMobileDevice && {
            width: 130,
          }),
        },
      },
    },
    totalItems: {
      color: theme.palette.red,
    },
  }),
);
